import { userListsClient } from 'src/clients'
import { UserList, UserListItem } from 'src/common-services'
import { useRecoilMutation, UseRecoilMutationOptions } from 'src/utils/recoil'
import * as atoms from 'src/atoms/user-lists'
import cloneDeep from 'lodash/cloneDeep'
import { growlError } from 'src/components/growl'

export const useAddUserListItem = (options?: UseRecoilMutationOptions<void>) =>
  useRecoilMutation(
    ({ set }) =>
      async (list: UserList, item: UserListItem | null) => {
        if (item === null) {
          return
        }
        try {
          const userListItem = await userListsClient.addListItem(list.id, item)
          set(atoms.userLists, (userLists) => {
            const originalUserLists = cloneDeep(userLists) || []
            if (item === null) {
              return originalUserLists
            }
            const userListIndex = originalUserLists.findIndex((li) => li.id === list.id)
            if (userListIndex === -1) {
              return originalUserLists
            }
            const userListItems = originalUserLists[userListIndex].items.concat(userListItem)
            originalUserLists[userListIndex].items = userListItems
            return originalUserLists
          })
        } catch (error) {
          growlError(error as Error, `Unable to add item to ${list.name}`)
        }
      },
    [],
    { ...options }
  )

export const useRemoveUserListItem = (options?: UseRecoilMutationOptions<void>) =>
  useRecoilMutation(
    ({ set }) =>
      async (list: UserList, item: UserListItem | null) => {
        if (item === null) {
          return
        }
        if (!item.id) {
          return
        }
        try {
          await userListsClient.removeListItem(list.id, item.id)
          set(atoms.userLists, (userLists) => {
            const originalUserLists = cloneDeep(userLists) || []
            if (item === null) {
              return originalUserLists
            }
            const userListIndex = originalUserLists.findIndex((li) => li.id === list.id)
            if (userListIndex === -1) {
              return originalUserLists
            }
            originalUserLists[userListIndex].items = originalUserLists[userListIndex].items.filter(
              (it) => it.id !== item.id
            )
            return originalUserLists
          })
        } catch (error) {
          growlError(error as Error, `Unable to remove item from ${list.name}`)
        }
      },
    [],
    { ...options }
  )
